import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormlyModule } from "@ngx-formly/core";
import { PrimeTemplate } from "primeng-v17/api";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiFormlyDatepickerComponent } from "./new-ui-formly-datepicker.component";
import { DatepickerComponent } from "../../shared/form/datepicker/datepicker.component";

@Component({
  selector: "app-formly-datepicker",
  templateUrl: "./formly-datepicker.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormElementMapModule,
    TestIdDirective,
    FormlyModule,
    NgIf,
    PrimeTemplate,
    DatepickerComponent,
  ],
})
export class FormlyDatepickerComponent extends NewUiFormlyDatepickerComponent {}
